import PropTypes from "prop-types";
import classNames from "classnames";

const StepIndicators = ({ steps, currentStep }) => {
  return (
    <div className="flex justify-center mb-4">
      <div className="flex space-x-4">
        {steps.map((step) => (
          <div key={`step-${step.index}`} className="flex items-center">
            <div
              className={classNames(
                "w-6 h-6 rounded-full flex items-center justify-center",
                {
                  "bg-blue-500 text-white": currentStep === step.index,
                  "bg-gray-200 text-gray-600": currentStep !== step.index,
                }
              )}
            >
              {step.index + 1}
            </div>
            <div
              className={classNames("ml-2 text-sm font-medium", {
                "text-blue-500": currentStep === step.index,
                "text-gray-500": currentStep !== step.index,
              })}
            >
              {step.label}
            </div>
            {step.index < steps.length - 1 && (
              <div className="w-8 h-0.5 bg-gray-200 mx-2" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

StepIndicators.propTypes = {
  steps: PropTypes.array.isRequired,
  currentStep: PropTypes.number.isRequired,
};

export default StepIndicators;
